module.exports = __webpack_public_path__ + "static/media/eslexpress.c2d3404c.png";